import Vue from 'vue';
import PwrForm from '../components/common/form/PwrForm.vue';
import PwrFormGroup from '../components/common/form/PwrFormGroup.vue';
import PwrFormRow from '../components/common/form/PwrFormRow.vue';
import PwrSubmit from '../components/common/form/PwrSubmit.vue';
import PwrUnauthenticated from '../components/common/page/PwrUnauthenticated.vue';
import LoadingSpinner from '../components/common/LoadingSpinner.vue';

export default function injectCommonComponents() {
  Vue.component('pwr-unauthenticated', PwrUnauthenticated);
  Vue.component('pwr-form', PwrForm);
  Vue.component('pwr-form-group', PwrFormGroup);
  Vue.component('pwr-form-row', PwrFormRow);
  Vue.component('pwr-submit', PwrSubmit);
  Vue.component('loading-spinner', LoadingSpinner);
}
